
import Header from '@/components/jobBooking/Header/Header.vue';
import PageCard from '@/components/jobBooking/pageCard/PageCard.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import * as routeNames from '@/router/routeNames';

@Component({
  components: {
    BackButton,
    Header,
    PageCard,
  },
  computed: {
    ...mapState(['user']),
  },
})
export default class JobBooking extends Vue {
  public routeNames = routeNames;
}
